import styled,{css} from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { breakpoints,device } from "../../../utils/responsive_utilities";
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';
import { white } from '../../../components/loggedout/shared-styles/Colors';
import { assetPath } from '../../../../js/utils/web-helper';
import BlueWaveMob from "~images/sem/blue-wave-mob.svg";
import BlueWaveWeb from "~images/sem/blue-wave-web.svg";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: url(${assetPath(BlueWaveMob)}) center center/cover no-repeat;
  ${styledFont('Graphie')}
  padding: 4rem 1.6rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${device.PhoneLandscape} {
    padding: 4rem 6rem 5rem;
    background: url(${assetPath(BlueWaveWeb)}) center center/cover no-repeat;
  }
  @media (min-width: ${breakpoints.md}px) {
    padding: 2rem 9rem 7rem;
    background: url(${assetPath(BlueWaveWeb)}) center center/cover no-repeat;
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 9rem 2rem 10rem;
    background: url(${assetPath(BlueWaveWeb)}) center center/cover no-repeat;
  }
  @media ${device.Desktop} {
    padding: 9rem 2rem 12.6rem;
    background: url(${assetPath(BlueWaveWeb)}) center center/cover no-repeat;
  }
  }
`;
export const HeadingText = styled.h2`
  color: ${white};
  margin: auto;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.6, 7)};
  }
`;
export const SubHeadingText = styled(SubHeading)`
  width: auto;
  color: ${white};
  ${styledFont("Graphie", 2, 2.4, 7)};
  margin: 14rem 0 0 0;
  text-align: left;
  padding-top: 1rem;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 3.6, 4, 7)};
    padding-top: 4rem;
    margin-top: 4rem;
  }
`;
export const ListWrapper = styled.ul`
  list-style: none;
  
`;

export const RatingImageWrapper = styled.div`
  padding: 2rem 0;
`;

export const Rating = styled.p`
  margin: 0;
  ${styledFont("Graphie", 1.6, 2.4, 7)}
  color: ${white};
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 2, 2.4, 7)};
  }
`;

export const ButtonWrapper = styled(CTAButtonWrapper)`
  >div {
    width: 25.2rem;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: space-around;    
  margin-top: 6.2rem;
  margin-bottom: 5.9rem;
  width: 100%;
  img{
    width: 9.6rem;
    height: 12.6rem;   
  }
  @media (min-width: ${breakpoints.md}px) {
    max-width: 77rem;
    margin: 5.1rem auto 4.9rem;
    img{
      width: 13.2rem;
      height: 17.6rem;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    max-width: 77rem
    margin: 6.8rem auto 8rem;
    img{
      width: 13.4rem;
      height: 17.9rem;
    }
  }
  @media ${device.Desktop} {
    margin: 3.5rem auto 9rem;
    img{
      width: 18.8rem;
      height: 25.1rem;
    }
  } 
`;